module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M7.5,44.9c0.5,0.5,1.3,0.5,1.6,0l23-23.4l22.8,23.2c0.5,0.5,1.2,0.5,1.6,0c0.5-0.5,0.5-1.2,0-1.6L32.9,19 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.2-0.9,0.4L7.3,43.3C7,43.6,7,44.4,7.5,44.9z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./frontend/images/icons/chevron-up.svg
// module id = 732
// module chunks = 0